import { render } from "./UiPropString.vue?vue&type=template&id=4705f568"
import script from "./UiPropString.vue?vue&type=script&lang=js"
export * from "./UiPropString.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__